import { PayMethod } from "./payment";

export interface Refund {
  id: string;
  treatmentId: string;
  needPayAmount: number;
  patientId: string;
  patientName: string;
  payMethod: PayMethod;
  realPayAmount: number;
  receivePayAmount: number;
  refundTime: string;
  returnPayAmount: number;
  shouldPayAmount: number;
}

export function fromJson(
  json: {
    id?: number;
    treatmentId?: number;
    patientId?: number;
    paymentId?: number;
  } & Record<string, never>
): Refund {
  return {
    id: json.id?.toString() || "",
    treatmentId: json.treatmentId?.toString() || "",
    needPayAmount: json.needPayAmount,
    patientId: json.patientId?.toString() || "",
    patientName: json.patientName,
    payMethod: json.payMethod || PayMethod.Cash,
    realPayAmount: json.realPayAmount,
    receivePayAmount: json.receivePayAmount,
    refundTime: json.refundTime,
    returnPayAmount: json.returnPayAmount,
    shouldPayAmount: json.shouldPayAmount,
  };
}
